import { motion } from "framer-motion";
import { Reveal } from "@/lib/motion";
import { DANDELION } from "@/data/site";

export const Dandelion = () => (
  <section data-testid="dandelion" className="section-pad bg-white relative overflow-hidden">
    <img
      src="/dandelion-mark.png"
      alt=""
      aria-hidden
      draggable={false}
      className="pointer-events-none select-none absolute -top-14 left-1/2 -translate-x-1/2 w-[300px] md:w-[420px] opacity-[0.16]"
    />
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-[#999999] mb-6 font-mono">The Dandelion Method</p>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] max-w-4xl text-[#111111]">
          A Differentiated Approach To Content That Compounds.
        </h2>
        <p className="mt-6 max-w-2xl text-lg text-[#666666] leading-relaxed">
          We plant strategic seeds that spread across Google, ChatGPT, Perplexity, and your entire buyer journey.
        </p>
      </Reveal>

      <div className="mt-16 border-t border-[#111111]">
        {DANDELION.map((step, i) => (
          <motion.div
            key={step.n}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.05, ease: [0.76, 0, 0.24, 1] }}
            className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-10 md:py-12 border-b border-[#E0E0E0] hover:bg-[#F5F5F5] transition-colors px-2 md:px-6 -mx-2 md:-mx-6"
          >
            <div className="md:col-span-3 flex items-center gap-4">
              <span className="font-serif text-6xl md:text-7xl lg:text-8xl leading-none text-[#111111] group-hover:italic transition-all">
                {step.n}
              </span>
            </div>
            <div className="md:col-span-4">
              <h3 className="font-serif text-2xl md:text-3xl text-[#111111]">{step.title}</h3>
            </div>
            <div className="md:col-span-5">
              <p className="text-base md:text-lg text-[#666666] leading-relaxed">{step.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
